import { createUtility } from '../lib';
export const Fluid = createUtility('fluid', ({ fluid }) => {
    return fluid ? `w--100` : null;
});
//# sourceMappingURL=fluid.js.map